// quoteLock.js
//
// Post-signature lock. Once a quote's Service Order / service agreement has been
// SIGNED (client) or COMPLETED (fully executed), the quote's commercial terms are
// frozen — a signed contract must not be silently re-priced or re-scoped. From
// that point only internal notes may change; every quote page enforces this at the
// save layer (the authoritative guarantee) and reflects it visually with a lock
// banner + disabled input panes.
//
// The signal lives in quotes.inputs.signwellDocuments[] — the same array the
// signature cards / webhook maintain. We look for any AGREEMENT-type doc (the
// binding Service Order / agreement, NOT an LOA or dialing waiver) whose status is
// signed or completed. Status casing is normalized (SignWell may send "Sent"/
// "Completed"; see signatureDocs.js).

export const AGREEMENT_DOC_TYPES = [
  'voice_quote', 'bundle_quote', 'flexit_quote', 'service_order', 'managed_it_quote',
];

const LOCKED_STATUSES = new Set(['signed', 'completed']);

/** True when the quote has a signed/completed binding agreement → terms frozen. */
export function isQuoteLocked(quote) {
  if (!quote) return false;
  const docs = quote.inputs?.signwellDocuments;
  if (!Array.isArray(docs)) return false;
  return docs.some(
    (d) =>
      d &&
      AGREEMENT_DOC_TYPES.includes(d.type) &&
      LOCKED_STATUSES.has(String(d.status || '').toLowerCase())
  );
}

export const QUOTE_LOCK_REASON =
  'This quote has a signed agreement and is locked. Only internal notes can be edited.';
